import { AdsCabinetsParams, AdsCabinetForCreate, AdsCabinetFromServer } from "@/store/dictionaries/ads_cabinets";
import { formatSettingsForDisplay } from "@/services/utils/Objects";

export function areAdsCabinetFieldsValid(adsCabinet: AdsCabinetForCreate): boolean {
    return !(!adsCabinet.name || !adsCabinet.token || !adsCabinet.source_slug || !adsCabinet.login)
}

export function setAdsCabinetsParamsByFilter(params: AdsCabinetsParams, settings: TableSettings) {
    if (settings.orderField) {
        params.order_by = settings.orderField;
    } else {
        params.order_by = '-mtime';
    }

    if (settings.commonFilter) {
        params.name__ilike = settings.commonFilter;
    }

    if (Object.keys(settings.filter).length > 0) {
        if (settings.filter.name) {
            params.name__ilike = settings.filter.name;
        }

        if (settings.filter.login) {
            params.login__ilike = settings.filter.login;
        }

        if (settings.filter.external_id) {
            params.external_id__ilike = settings.filter.external_id;
        }

        if (settings.filter.source_slug.length > 0) {
            params.source_slug__in = settings.filter.source_slug.join(",");
        }

        if (settings.filter.is_statistics_required) {
            params.is_statistics_required = settings.filter.is_statistics_required;
        }

        if (settings.filter.is_naming_checked.length > 0) {
            params.is_naming_checked = settings.filter.is_naming_checked == "1" ? true : false;
        }

        if (settings.filter.use_in_ui.length > 0) {
            params.use_in_ui = settings.filter.use_in_ui == "1" ? true : false;
        }
    }
}

interface TableSettings {
    first: number;
    orderField: string;
    commonFilter: string;
    filter: FilterForm;
}

export interface FilterForm {
    name: string;
    login: string;
    external_id: string;
    source_slug: string[];
    is_statistics_required: boolean;
    is_naming_checked: string;
    use_in_ui: string;
}

export interface AdsCabinetFormData {
    name: string;
    source_slug: string | null;
    login: string;
    external_id: string | null;
    is_statistics_required: boolean;
    is_naming_checked: boolean;
    token: string;
    use_in_ui: boolean;
    settings: string | null;
}


export function mapAdsCabinetFromServerToForm(adsCabinetFromServer: AdsCabinetFromServer): AdsCabinetFormData {
    return {
        name: adsCabinetFromServer.name,
        source_slug: adsCabinetFromServer.source_slug,
        login: adsCabinetFromServer.login,
        external_id: adsCabinetFromServer.external_id || null,
        is_statistics_required: adsCabinetFromServer.is_statistics_required,
        token: "************",
        is_naming_checked: adsCabinetFromServer.is_naming_checked,
        use_in_ui: adsCabinetFromServer.use_in_ui || false,
        settings: formatSettingsForDisplay(adsCabinetFromServer.settings),
    };
}